




import {Component, Prop, Vue} from "vue-property-decorator"
import DataGrid, {DataType} from "@/components/DataGrid.vue"
import DataGridLink from "@/components/buttons/DataGridLink.vue"
import * as complianceLinks from "@/data/sources/complianceLinks"
import {executeQuery} from "@/data/repos/query";

@Component({
  components: {
    DataGrid,
  },
})
export default class ComplianceSingleElementScoreDrillDown extends Vue {
  @Prop() public args!: { locationId: number, elementId: number }
  public fields = [
    {name: "elementDescription", title: "Element", dataType: DataType.Text, sort: 1, component: DataGridLink, callback: complianceLinks.element},
    {name: "buildingName", title: "Building", dataType: DataType.Text, sort: 1, component: DataGridLink, callback: complianceLinks.building},
    {name: "code", title: "Code", dataType: DataType.Text, sort: 1},
    {name: "reason", title: "Reason", dataType: DataType.Text, sort: 1},
    {name: "expiryDate", title: "Expiry Date", dataType: DataType.Date, sort: 1},
    {name: "responsiblePerson", title: "Responsible Person", dataType: DataType.Text, sort: 1},
    {name: "riskLabel", title: "Risk", dataType: DataType.Text, sort: 1},
  ]

  public getData(offset: number = 0, limit: number = 250) {
    const locationId = this.args.locationId
    const elementId = this.args.elementId
    return executeQuery("idr", "compliance.singleElementScoreDrillDown",
      {locationId, elementId},
      undefined,
      offset, limit)
  }
}
